import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { Tenant } from '../../../../model/tenant';
import { Organization } from '../../../../model/organization';
import { FormGroup } from '@angular/forms';
import { TimezoneService } from '../../../../services/timezone.service';
import {MeasurementType} from "../../../../model/measurement-type";

@Component({
  selector: 'app-kpis-form-info',
  templateUrl: './kpis-form-info.component.html',
  styleUrls: ['./kpis-form-info.component.scss']
})
export class KpisFormInfoComponent implements OnInit {

  @Input() kpiInfoForm: FormGroup;
  @Input() mode: 'create' | 'edit';
  @Input() tenants: Tenant[];
  @Input() organizations: Organization[];
  @Input() measurementTypes: MeasurementType[];

  @Output() tenantChange: EventEmitter<Tenant>;
  @Output() organizationChange: EventEmitter<Organization>;

  public creationModes: SelectItem[];
  public timePeriods: SelectItem[];
  public operations: SelectItem[];
  timezones: any[];

  constructor(
    private timezoneService: TimezoneService
  ) {
    this.tenantChange = new EventEmitter<Tenant>();
    this.organizationChange = new EventEmitter<Organization>();
    this.creationModes = [
      { label: 'misc.kpiCreationMode.single', value: 'SINGLE' },
      { label: 'misc.kpiCreationMode.multiple', value: 'MULTIPLE' }
    ];
    this.timePeriods = [
      { label: 'misc.timePeriod.hourly', value: 'HOURLY' },
      { label: 'misc.timePeriod.daily', value: 'DAILY' },
      { label: 'misc.timePeriod.weekly', value: 'WEEKLY' },
      { label: 'misc.timePeriod.monthly', value: 'MONTHLY' },
    ];
    this.operations = [
      { label: 'misc.operation.sum', value: 'SUM' },
      { label: 'misc.operation.count', value: 'COUNT' },
      { label: 'misc.operation.min', value: 'MIN' },
      { label: 'misc.operation.max', value: 'MAX' },
      { label: 'misc.operation.average', value: 'AVERAGE' },
      { label: 'misc.operation.increment', value: 'INCREMENT' },
    ];
  }

  ngOnInit(): void {
    this.timezones = this.timezoneService.getAllTimezones();
    if (!this.kpiInfoForm.get('timezone').value) {
      this.kpiInfoForm.get('timezone').setValue(this.timezoneService.getCurrentTimezone());
    }
  }

  public onOrganizationChange(event): void {
    this.organizationChange.emit(event.value);
  }

  public onTenantChange(event): void {
    this.tenantChange.emit(event.value);
  }

}
